module.exports = __webpack_public_path__ + "static/media/0321_IMG_LE_SOL_CARRELAGE_EXISTANT.cdae42db.png";